import { Controller } from "@hotwired/stimulus";

const FIELD = (name: string) => document.getElementById(`character_race_${name}`) as HTMLInputElement | null;

// The race form's Ajudante card: the lines the retainer picker shows under the race
// (CharacterRace#retainer_info_lines), from the Movimento and Infravisão fields above
// and the restriction typed here.
export default class extends Controller<HTMLElement> {
	static targets = ["restriction", "count", "tileName", "lines"];
	static values = { phrases: Object };

	declare readonly restrictionTarget: HTMLInputElement;
	declare readonly countTarget: HTMLElement;
	declare readonly tileNameTarget: HTMLElement;
	declare readonly linesTarget: HTMLElement;
	declare readonly phrasesValue: Record<string, string | Record<string, string>>;

	// Movimento and Infravisão are not inside this card, so the card's own
	// `input` action never hears them.
	private readonly onInput = () => this.update();
	private readonly watched = ["name", "mv", "mve", "mvn", "mvv", "infravision"];

	connect() {
		for (const name of this.watched) FIELD(name)?.addEventListener("input", this.onInput);
		this.update();
	}

	disconnect() {
		for (const name of this.watched) FIELD(name)?.removeEventListener("input", this.onInput);
	}

	update() {
		this.countTarget.textContent = String(this.restrictionTarget.value.length);
		this.tileNameTarget.textContent = FIELD("name")?.value.trim() || this.say("fallback");

		const lines = [`${this.movement()}.`];
		if (Number(FIELD("infravision")?.value) > 0) lines.push(this.say("infravision", { infravision: FIELD("infravision")?.value ?? "" }));
		if (this.restrictionTarget.value.trim()) lines.push(this.restrictionTarget.value);

		this.linesTarget.replaceChildren(
			...lines.map((line) => {
				const div = document.createElement("div");
				div.textContent = line;
				return div;
			}),
		);
	}

	private say(key: string, vars: Record<string, string> = {}) {
		return String(this.phrasesValue[key] ?? "").replace(/%\{(\w+)\}/g, (_, name) => vars[name] ?? "");
	}

	private movement() {
		const parts = [this.say("base", { mv: FIELD("mv")?.value ?? "" })];
		for (const [field, key] of [
			["mve", "climbing"],
			["mvn", "swimming"],
			["mvv", "flying"],
		] as const) {
			const value = FIELD(field)?.value ?? "";
			if (value !== "") parts.push(this.say(key, { [field]: value }));
		}
		const connectors = this.phrasesValue.connectors as Record<string, string>;
		if (parts.length < 3) return parts.join(connectors.two_words_connector);
		return `${parts.slice(0, -1).join(connectors.words_connector)}${connectors.last_word_connector}${parts[parts.length - 1]}`;
	}
}
